if (!customElements.get('cart-personalize-more')) {
  customElements.define('cart-personalize-more', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelector('[data-personalize-another]')?.addEventListener('click', event => {
        const wizard = [...document.querySelectorAll('vintage-personalizer')].find(el =>
          el.closest('form')?.querySelector('[name="product-id"]')?.value === this.dataset.productId
        );
        if (!wizard?.resetForNewDesign) return;
        if (wizard.submit?.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        const drawer = this.closest('cart-drawer');
        if (!drawer) return;
        drawer.close();
        const start = () => {
          if (!drawer.classList.contains('active') && !drawer.isCartUpdating) wizard.resetForNewDesign();
        };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) requestAnimationFrame(start);
        else setTimeout(start, 350);
      }, { signal:this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

